import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div>
        <title>
          Social Media Preview
        </title>
        <meta property="og:url" content="your url" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="your fb app id" />
        <meta
          property="og:title"
          content="Social Media Preview Working?"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          property="og:description"
          content="Hurray!! Yes Social Media Preview is Working"
        />
        <meta property="og:image" content={"url of image"} />
      <h2>
        Hurray!!! The Website is Complete. Lets Try Social Media Preview Now
      </h2>
    </div>
  );
}

export default App;
